var $ = require('jquery');

module.exports = {
	init : function() {
		var $toggler = $('.how-hearFieldArea .dk_toggle'), opened = false;

		$toggler.on('click', function() {
			var $parent = $(this).closest('.contact-section');
			if (!opened) {
				// $parent.css('padding-bottom', '140px');
				$parent.animate({
					'padding-bottom' : '140px'
				}, 100, 'easeOutQuad');
				opened = true;
			} else {
				$parent.animate({
					'padding-bottom' : '30px'
				}, 100, 'easeOutQuad');
				opened = false;
			}
		});

//		$(function() {
//			$(".move-in-dateFieldArea input").datepicker();
//		});
	}
};
